@if ((sendLoading$ | async)) {
  <mat-dialog-content
    fxLayout="column">
    <div fxLayout="row"
      fxLayoutAlign="start"
      [ngClass]="{'engage-confirmation-dialog__mobile-loader-container': (isMobile$ | async)}">
      <div class="engage-confirmation-dialog__loading-wheel"
        [ngClass]="{'engage-confirmation-dialog__mobile-loading-wheel': (isMobile$ | async)}"
        [cfaLoading]="true">
      </div>
      <div class="engage-confirmation-dialog__loader-text-wrapper"
        [ngClass]="{'engage-confirmation-dialog__mb-loader-text-wrapper': (isMobile$ | async)}">
        <h3 class="engage-confirmation-dialog__loader-text">
          {{sendConfirmationAction$ | async}}
        </h3>
      </div>
    </div>
  </mat-dialog-content>
}
<!-- Show error -->
@if ((sendError$ | async) && !(sendLoading$ | async)) {
  <mat-dialog-content
    fxLayout="column"
    class="engage-confirmation-dialog__wrapper"
    [ngClass]="{'engage-confirmation-dialog__mobile-wrapper': (isMobile$ | async)}">
    @if (!(failedPlatforms$ | async) || (failedPlatforms$ | async).length == 0) {
      <div fxLayout="row" fxLayoutAlign="start">
        <div class="engage-confirmation-dialog__icon-wrapper"
          [ngClass]="{'engage-confirmation-dialog__mobile-icon-wrapper': (isMobile$ | async)}">
          @if ((sendError$ | async)) {
            <span>
              <mat-icon class="engage-confirmation-dialog__error-icon"
                [ngClass]="{'engage-confirmation-dialog__mobile-error-icon': (isMobile$ | async)}">
                warning
              </mat-icon>
            </span>
          }
        </div>
        <div>
          @if (sendError$ | async) {
            <h3 class="engage-confirmation-dialog__heading-text"
              [ngClass]="{'engage-confirmation-dialog__mobile-heading-text': (isMobile$ | async)}">
              {{(sendConfirmationAction$ | async).headingMessage}}
            </h3>
            <p class="engage-confirmation-dialog__sub-text engage-confirmation-dialog__error-sub-text">
              {{(sendConfirmationAction$ | async).errorSubText}}
            </p>
          }
        </div>
      </div>
    }
    <!-- Show Third Party Error -->
    @if ((failedPlatforms$ | async) && (failedPlatforms$ | async).length > 0) {
      <div fxLayout="row" fxLayoutAlign="start">
        <div fxLayout="column">
          <h3 class="engage-confirmation-dialog__heading-text"
            [ngClass]="{'engage-confirmation-dialog__mobile-heading-text': (isMobile$ | async)}">
            This promotion is only active on {{successfulPlatforms$ | async}}. Do you want to continue?
          </h3>
          <p class="engage-confirmation-dialog__sub-text">
            It will not be available on {{failedPlatforms$ | async}}.
          </p>
        </div>
      </div>
    }
  </mat-dialog-content>
}
<!-- success message -->
@if (!(sendLoading$ | async) && !(sendError$ | async)) {
  <mat-dialog-content
    fxLayout="column"
    class="engage-confirmation-dialog__wrapper"
    [ngClass]="{'engage-confirmation-dialog__mobile-wrapper': (isMobile$ | async)}">
    <div fxLayout="row"
      fxLayoutAlign="start">
      <div class="engage-confirmation-dialog__icon-wrapper"
        [ngClass]="{'engage-confirmation-dialog__mobile-icon-wrapper': (isMobile$ | async)}">
        @if (!(areAllDuplicates$ | async) && !(sendError$ | async)) {
          <span>
            <mat-icon class="engage-confirmation-dialog__success-icon"
              [ngClass]="{'engage-confirmation-dialog__mobile-success-icon': (isMobile$ | async)}">
              check_circle_outline
            </mat-icon>
          </span>
        }
        @if ((areAllDuplicates$ | async) || (sendError$ | async)) {
          <span
            [ngClass]="{'engage-confirmation-dialog__mobile-icon-wrapper': (isMobile$ | async)}">
            <mat-icon class="engage-confirmation-dialog__error-icon"
              [ngClass]="{'engage-confirmation-dialog__mobile-error-icon': (isMobile$ | async)}">
              warning
            </mat-icon>
          </span>
        }
      </div>
      <div>
        @if (!(areAllDuplicates$ | async) && !(sendError$ | async)) {
          <h3 class="engage-confirmation-dialog__heading-text"
            [ngClass]="{'engage-confirmation-dialog__mobile-heading-text': (isMobile$ | async)}">
            {{(sendConfirmationAction$ | async).headingMessage}}
          </h3>
          <p class="engage-confirmation-dialog__sub-text">
            {{(sendConfirmationAction$ | async).subText}}
          </p>
        }
        @if ((areAllDuplicates$ | async) && !(sendError$ | async)) {
          <h3 class="engage-confirmation-dialog__heading-text"
            [ngClass]="{'engage-confirmation-dialog__mobile-heading-text': (isMobile$ | async)}">
            Please Note
          </h3>
          <p class="engage-confirmation-dialog__sub-text">
            All customers selected in this reward campaign have the same item already available.
            To send duplicate reward(s) to Customer(s) for recovery needs, use either the “Sorry for the Snag” or “We
            Apologize” reward theme.
            Otherwise, try changing the dates or selecting a different reward.
          </p>
        }
      </div>
    </div>
  </mat-dialog-content>
}
@if (!(sendLoading$ | async)) {
  <mat-dialog-content
    fxLayout="column"
    class="engage-confirmation-dialog__wrapper"
    [ngClass]="{'engage-confirmation-dialog__mobile-wrapper': (isMobile$ | async)}">
    <div fxLayout="row"
      fxLayoutAlign="space-around start">
      <div fxFlex="100">
        <div mat-dialog-actions
          class="engage-confirmation-dialog__btn-wrapper"
          [ngClass]="{'engage-confirmation-dialog__mobile-btn-wrapper': (isMobile$ | async)}">
          @if (page === engagePage && !(areAllDuplicates$ | async) && !(sendError$ | async)) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__action-btn"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="goToCalendar()">
              View on Calendar
            </button>
          }
          @if (page === engagePage && (mode$|async) != editMode) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__action-btn"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="backToEngage()">
              Back to Engage
            </button>
          }
          @if (page === engagePage && (mode$ |async) == editMode && (sendError$|async)) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__action-btn"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="backToFullCalendar()">
              Back to Calendar
            </button>
          }
          @if (page === discoverPage && (type$ | async) === thirdPartyPromotionType && (!(failedPlatforms$ | async) || (failedPlatforms$|async).length == 0) && !(sendError$|async)) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__cancel-button"
              [ngClass]="{'engage-confirmation-dialog__mobile-cancel-btn': (isMobile$ | async)}"
              (click)="goToCalendar()">
              Calendar View
            </button>
          }
          @if (page === discoverPage && (failedPlatforms$ | async).length == 0) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__action-btn"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="goBack()">
              Go Back
            </button>
          }
          @if (page === discoverPage && (type$ |async) === thirdPartyPromotionType && ((failedPlatforms$ | async) && (failedPlatforms$ | async).length > 0 )) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__cancel-button"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="cancelThirdPartyPromotion()">
              Cancel Promotion
            </button>
          }
          @if (page === discoverPage && (type$ |async) === thirdPartyPromotionType && ((failedPlatforms$ | async) && (failedPlatforms$ | async).length > 0 )) {
            <button
              mat-raised-button
              class="engage-confirmation-dialog__action-btn"
              [ngClass]="{'engage-confirmation-dialog__mobile-action-btn': (isMobile$ | async)}"
              (click)="createThirdPartyPromotion()">
              Continue
            </button>
          }
        </div>
      </div>
    </div>
  </mat-dialog-content>
}
